var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncubateIdea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.4995,
    r: 40.5,
    fill: "#BAF4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1343 31.9076V39.2485H20.0724V31.9076C20.0724 31.5831 20.2043 31.2719 20.4393 31.0424C20.6742 30.813 20.9928 30.6841 21.325 30.6841H48.8817C49.2139 30.6841 49.5325 30.813 49.7674 31.0424C50.0023 31.2719 50.1343 31.5831 50.1343 31.9076Z",
    fill: "#44AB96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1343 41.6953V49.0362C50.1343 49.3607 50.0023 49.6719 49.7674 49.9014C49.5325 50.1308 49.2139 50.2597 48.8817 50.2597H21.325C20.9928 50.2597 20.6742 50.1308 20.4393 49.9014C20.2043 49.6719 20.0724 49.3607 20.0724 49.0362V41.6953H50.1343Z",
    fill: "#44AB96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4526 30.6812H60.2335C60.5332 30.6812 60.8207 30.7693 61.0326 30.9263C61.2446 31.0833 61.3637 31.2963 61.3637 31.5183V49.9349C61.3637 50.157 61.2446 50.3699 61.0326 50.5269C60.8207 50.6839 60.5332 50.7721 60.2335 50.7721H53.4526V30.6812Z",
    fill: "#44AB96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncubateIdea);
export default __webpack_public_path__ + "static/media/incubateIdea.2e786d322e85029f44cc009d8cf9d78c.svg";
export { ForwardRef as ReactComponent };